export const PAGE_GUTTER = { xs: 'var(--space-4)', md: 'var(--space-8)' };

export const pageGutterSx = { px: PAGE_GUTTER };
